export default "__VITE_ASSET__B8V9jHa___"